<div class="flex gap-20 mb-20 align-items-center">
    <div class="pointer" (click)="navigateHome()">
        <img class="arrow pointer" width="20px" (click)="navigateHome()" src="assets/arrow-left.svg">
        <p class="dark-blue no-margin text-xs">Retour</p>
    </div>
    <div class="flex gap-10 align-items-center">
        <img src="assets/results-icon.svg" alt="page icon">
        <h1 class="light-blue no-margin">Résultats</h1>
    </div>
</div>

<div class="bg-white w-full radius-10 border-box">
    <div style="border-bottom: solid 1px #DCEEFF;" class="p-20">
        <div class="flex content-between">
            <div>
                <p class="dark-blue bold no-margin mb-10 text-lg">{{pollData.name}}</p>
                <div class="flex align-items-center" (click)="goToAuditPage()">
                    <img src="assets/v8te-icon.svg" height="15px">
                    <span class="download-text">Audit d'intégrité</span>
                </div>
                <!-- <p >{{pollData.description}}</p> -->
            </div>
            <div class="w-20 flex flex-column align-items-end gap-10">
                <div class="flex gap-10 align-items-start">
                    <img src="assets/completed-poll-icon.svg" width="30px" alt="status icon">
                    <div>
                        <p class="dark-gray no-margin text-sm">
                            Statut du scrutin
                        </p>
                        <p class="dark-blue bold no-margin">
                            TERMINÉ
                        </p>
                    </div>
                </div>
                <div class="w-full" *ngIf="!assessorsValidated">
                    <p class="dark-blue no-margin text-right" style="margin-bottom: 5px;"><img width="18px"
                            id="silhouette" style="margin-right: 10px;"
                            src="assets/silhouette_icon_black.svg">Assesseurs : <span class="bold">{{assessorCount
                            -
                            inactiveAssessors}}/{{requiredAssessors}}</span></p>
                    <p-progressBar [value]="((assessorCount - inactiveAssessors) / requiredAssessors) * 100"
                        [showValue]="false"></p-progressBar>
                </div>

                <v8te-active-button class="w-full" [buttonText]="'Voir les assesseurs manquants'" [primaryColor]="'#FFFFFF'"
                    [textPrimaryColor]="'#1990FF'" [border]="'solid 1px #1990FF'" [height]="'40px'" [minWidth]="'120px'"
                    (click)="viewMissingAssessors()" [widthPercent]="'100'"></v8te-active-button>
                <v8te-active-button class="w-full" *ngIf="canResendAssessors" [buttonText]="'TIMER.ASS-RELAUNCH' | translate"
                    [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#1990FF'" [border]="'solid 1px #1990FF'"
                    [height]="'40px'" [minWidth]="'120px'" (click)="relaunchAssessors()"
                    [widthPercent]="'100'"></v8te-active-button>

                <v8te-active-button class="w-full" *ngIf="!canResendAssessors" [buttonText]="'TIMER.ASS-RELAUNCH' | translate"
                    [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#1990FF'" [border]="'solid 1px #1990FF'"
                    [height]="'40px'" [minWidth]="'120px'" [widthPercent]="'100'" [active]="false" [cursor]="'default'">
                </v8te-active-button>

            </div>
        </div>
    </div>


    <div class="p-20" style="display: grid; grid-template-columns: 40% 60%">
        <div>
            <!-- <div class="flex gap-10 mb-10 align-items-center">
                <img width="40px" src="assets/calendar-blue-icon.svg">
                <p class="dark-blue bold no-margin">Premier tour</p>
            </div> -->

            <div class="flex gap-20">
                <div>
                    <p class="dark-gray no-margin text-sm mb-10">
                        Date d'ouverture
                    </p>
                    <p class="dark-blue bold no-margin">
                        {{startDate}}
                    </p>
                </div>

                <div>
                    <p class="dark-gray no-margin text-sm mb-10">
                        Date de clôture
                    </p>
                    <p class="dark-blue bold no-margin">
                        {{endDate}}
                    </p>
                </div>
            </div>
        </div>

        <div>
            <div class="flex gap-10 align-items-center mb-10">
                <img src="assets/histogram-icon.svg" alt="results icon">
                <p class="dark-blue bold no-margin">Résultats et représentativité syndicale</p>
            </div>

            <div class="flex content-between w-full">
                <div class="flex align-items-center gap-10">
                    <img width="20px" src="assets/download-icon.svg" alt="download icon">
                    <p class="light-blue no-margin text-sm pointer" (click)="downloadCerfa()">PV CERFA</p>
                </div>

                <div class="flex align-items-center gap-10">
                    <img width="20px" src="assets/teletransmission-icon.svg" alt="download icon">
                    <p class="light-blue no-margin text-sm pointer" (click)="teletransmissionClick()">Télétransmission</p>

                </div>

                <div class="flex align-items-center gap-10">
                    <img width="20px" src="assets/download-icon.svg" alt="download icon">
                    <p class="light-blue no-margin text-sm pointer" (click)="downloadResults()">
                        Fichier de résultats
                    </p>
                </div>

                <div class="flex align-items-center gap-10">
                    <img width="20px" src="assets/representative-icon.svg" alt="representative icon">
                    <p class="light-blue no-margin text-sm pointer" (click)="downloadRepresentation()">Représentativité
                    </p>
                </div>

            </div>
        </div>
    </div>


</div>
